import moment from 'moment';

// Data
import {
  consultClientAddressesFields,
  consultClientHiddenFields,
  insertAddressHiddenFields,
  registerClientDirectionHiddenFields,
  registerClientHiddenFields,
  serviceCredentials,
  updateClientHiddenFields,
} from "../config/servicesHiddenFields";


// Truncate a string to a given lenght

export const truncateString = (str, n) => {
  return str?.length > n ? str?.substr(0, n - 1) + "..." : str;
};

// Get a number value from a string

export const getNumberFromStringValueRange = (string) => {
  const split = string?.split('-');

  if (split?.length > 0) {
    return parseFloat(split[0].replaceAll(',', ''));
  } else {
    return 0;
  }
}


// Convert Java Date to Standard Date

export const convertJavaDateToStandardDate = (date) => {
  const formattedDdate = date ? new Date(date.replace('VET', '')) : '';
  const dateString = moment(formattedDdate).format()?.replace('-04:00', "-04:30");

  return dateString;
}


// Get current date minus X number of years

export const getCurrentDateMinusYears = (years) => {
  const date = moment().subtract(years, 'years');

  return date.toDate();
}

// Get current date minus X number of months

export const getCurrentDateMinusMonths = (months) => {
  const date = moment().subtract(months, 'months');

  return date.toDate();
}

// Get current date minus X number of days

export const getCurrentDateMinusDays = (days) => {
  const date = moment().subtract(days, 'days');

  return date.toDate();
}

// Set up client register data

export const setUpClientRegisterData = (data) => {
  let cliente = { ...data.cliente };
  let direccion;

  // Setup Client Values

  cliente.catEspec = cliente.categoriaEspecial;
  delete cliente.categoriaEspecial;

  cliente.cedula = cliente.tipoDocumento !== 'P' ? cliente.tipoDocumento + cliente.cedulaRif : "";

  cliente.pasaporte = cliente.tipoDocumento !== 'P' ? "" : cliente.tipoDocumento + cliente.pasaporte;

  cliente.venezolano = cliente.tipoDocumento === 'V' ? "true" : "false";
  delete cliente.cedulaRif;

  cliente.edoCivil = cliente.estadoCivil;
  delete cliente.estadoCivil;

  cliente.ocupacion = cliente.actividadEspecifica;
  delete cliente.actividadEspecifica;

  cliente.otraNacionalidad = cliente.codigoOtraNacionalidad ? Number(cliente.codigoOtraNacionalidad) : '99';
  delete cliente.codigoOtraNacionalidad;

  cliente.provincia = cliente.lugarNacimiento === '0' ? Number(cliente.ciudadNacimiento) : cliente.lugarNacimiento;
  delete cliente.estadoNacimiento;

  cliente.codiOf = cliente.oficinaAsesor;
  cliente.codOficina = cliente.oficinaAsesor;
  // delete cliente.officina;

  cliente.pais = cliente.lugarNacimiento;
  cliente.lugarNacimiento = cliente.lugarNacimiento === '0' ? 1 : 2;
  cliente.nacionalidad = Number(cliente.nacionalidad);

  delete cliente.ciudadNacimiento;
  delete cliente.fechaVencimiento;
  // delete cliente.oficinaAsesor;

  cliente.rif = cliente.tipoRif + cliente.rif;
  delete cliente.tipoRif;

  // cliente.fechaVencimiento = '';

  // cliente.fechaNacimiento = '2002-03-18T00:00:00-04:30';
  // cliente.fechaVenceIdentificacion = cliente.tipoDocumento !== 'P' ? '0000-00-00T00:00:00-00:00' : '2024-04-05T12:31:09-04:30';

  cliente.nombreCompleto = cliente.nombre + ' ' + cliente.primerApellido + ' ' + cliente.segundoApellido;

  cliente.fechaDesde = getCurrentDateMinusYears(Number(cliente.fechaDesde));

  // Setup Address Values

  if (data?.direccion?.pais === '0') {

    direccion = { ...registerClientDirectionHiddenFields, ...data.direccion };

    direccion.inmueble = direccion.tipoInmueble;

    if (direccion.tipoInmueble === '1') {
      direccion.casa = direccion.nombreInmueble;
    } else if (direccion.tipoInmueble === '5') {
      direccion.edificio = direccion.nombreInmueble;
    } else if (direccion.tipoInmueble === '2') {
      direccion.quinta = direccion.nombreInmueble;
    } else if (direccion.tipoInmueble === '3') {
      direccion.residencia = direccion.nombreInmueble;
    }

    direccion.telefono2 = direccion.telefono2?.numero ? {
      ...direccion.telefono2,
      tipoDireccion: 'T'
    } : {
      codigoArea: "000",
      descripcionTipoDireccion: 0,
      identificador: 2,
      numero: "0000000",
      tipo: "T",
      tipoDireccion: "D",
    }

    direccion.descDireccion = `${direccion.nombrePais}, ${direccion.entidad}, ${direccion.ciudad}, ${direccion.municipio}, ${direccion.parroquia}, ${direccion.urbanizacion},${direccion.callecarretera},${direccion.calle},${direccion.avenida},${direccion.esquina},OBSERVACIONES ${direccion.observaciones},TP INM ${direccion.tipoInmueble},NOM INM ${direccion.nombreInmueble},NIV ${direccion.piso},TEL ${direccion.telefono1.codigoArea + ' ' + direccion.telefono1.numero}`;

  } else {

    direccion = { ...registerClientDirectionHiddenFields };
    direccion.calle = '';
    direccion.entidad = '';
    direccion.inmueble = '';
    direccion.parroquia = '';
    direccion.municipio = '';
    direccion.urbanizacion = '';
    direccion.tipoInmueble = '';
    direccion.nivel = '';
    direccion.ciudad = data?.direccion?.pais;
    direccion.pais = data?.direccion?.pais;

    direccion.telefono1 = {
      ...data.direccion?.telefono1,
      tipoDireccion: "T"
    };
    direccion.telefono2 = data.direccion?.telefono2?.numero ? {
      ...data?.direccion?.telefono2,
      tipoDireccion: 'T'
    } : {
      codigoArea: "000",
      descripcionTipoDireccion: 0,
      identificador: 2,
      numero: "0000000",
      tipo: "T",
      tipoDireccion: "T",
    }

    direccion.descDireccion = `PAIS ${data.direccion?.nombrePais}, ${data?.direccion?.descDireccion}`;
    direccion.tipo = 'I';
    direccion.tipoDireccion = "I";

  }

  let resgisterData = {
    cliente: {
      ...cliente,
      ...registerClientHiddenFields,
    },
    direccionBean: direccion,
    oficinaAsesor: cliente.oficinaAsesor,
    // ...serviceCredentials,
  };

  return resgisterData;
};


// Set up client spouse register data

export const setUpClientSpouseRegisterData = (data) => {
  let clientData = setUpClientRegisterData(data);
  let spouseData = { ...data.conyuge };

  spouseData.cedula = spouseData.tipoDocumento !== 'P' ? spouseData.tipoDocumento + spouseData.cedulaRif : "";
  spouseData.pasaporte = spouseData.tipoDocumento !== 'P' ? "" : spouseData.tipoDocumento + spouseData.pasaporte;
  spouseData.venezolano = spouseData.tipoDocumento === 'V' ? "true" : "false";

  spouseData.nombreCompleto = spouseData.nombre + ' ' + spouseData.primerApellido + ' ' + spouseData.segundoApellido;

  let resgisterData = {
    cliente: {
      ...clientData?.cliente,
      ...spouseData,
      ...registerClientHiddenFields,
    },
    direccionBean: clientData?.direccionBean,
    oficinaAsesor: clientData?.cliente?.oficinaAsesor,
    // ...serviceCredentials,
  };

  return resgisterData;

}


// Set up client representative register data

export const setUpRepresentativeClientRegisterData = (data) => {
  let clientData = setUpClientRegisterData(data);
  let representativeData = { ...data.apoderado };
  let representativeAddress = { ...clientData?.direccionBean }

  representativeData.cedula = representativeData.tipoDocumento !== 'P' ? representativeData.tipoDocumento + representativeData.cedulaRif : "";
  representativeData.pasaporte = representativeData.tipoDocumento !== 'P' ? "" : representativeData.tipoDocumento + representativeData.pasaporte;
  representativeData.venezolano = representativeData.tipoDocumento === 'V' ? "true" : "false";

  representativeData.nombreCompleto = representativeData.nombre + ' ' + representativeData.primerApellido + ' ' + representativeData.segundoApellido;
  representativeData.rif = '';

  // Address Values

  if (representativeData.pais === '0') {

    representativeAddress.pais = representativeData.pais;
    representativeAddress.entidad = representativeData.entidad;
    representativeAddress.ciudad = representativeData.ciudad;
    representativeAddress.municipio = representativeData.municipio;
    representativeAddress.parroquia = representativeData.parroquia;
    representativeAddress.urbanizacion = representativeData.urbanizacion;
    representativeAddress.calle = representativeData.calle;

    representativeAddress.descDireccion = `PAÍS ${representativeAddress.pais},ESTADO ${representativeAddress.entidad},CIUDAD ${representativeAddress.ciudad},MUNICIPIO ${representativeAddress.municipio},PARROQUIA ${representativeAddress.parroquia},SECT ${representativeAddress.urbanizacion},${representativeAddress.calle},TP INM ${representativeAddress.tipoInmueble},NOM INM ${representativeAddress.nombreInmueble},NIV ${representativeAddress.piso},TEL ${representativeAddress.telefono1.codigoArea + representativeAddress.telefono1.numero},CEL ${representativeAddress.telefono2.codigoArea + representativeAddress.telefono2.numero}`;

  } else {
    representativeAddress.tipo = 'I';
    representativeAddress.tipoDireccion = "I";
    
    representativeAddress.calle = '';
    representativeAddress.entidad = '';
    representativeAddress.inmueble = '';
    representativeAddress.parroquia = '';
    representativeAddress.municipio = '';
    representativeAddress.urbanizacion = '';
    representativeAddress.tipoInmueble = '';
    representativeAddress.nivel = '';
    representativeAddress.ciudad = representativeData?.pais;
    representativeAddress.pais = representativeData?.pais;
    
    representativeAddress.descDireccion = `PAIS ${representativeData?.nombrePais}, ${representativeData?.descDireccion}`;

    representativeAddress.telefono1 = {
      ...data.direccion?.telefono1,
      tipoDireccion: "T"
    };
    representativeAddress.telefono2 = {
      codigoArea: "000",
      descripcionTipoDireccion: 0,
      identificador: 2,
      numero: "0000000",
      tipo: "T",
      tipoDireccion: "T",
    }
  }

  // Remove extra fields

  delete representativeData.pais;
  delete representativeData.entidad;
  delete representativeData.ciudad;
  delete representativeData.municipio;
  delete representativeData.parroquia;
  delete representativeData.urbanizacion;
  delete representativeData.calle;
  delete representativeData.identificacionRegistro;
  delete representativeData.numeroRegistro;
  delete representativeData.tomoRegistro;
  delete representativeData.protocolo;
  delete representativeData.fechaRegistro;
  delete representativeData.nombrePais;
  delete representativeData.descDireccion;

  let resgisterData = {
    cliente: {
      ...clientData?.cliente,
      ...representativeData,
      ...registerClientHiddenFields,
    },
    direccionBean: representativeAddress,
    oficinaAsesor: clientData?.cliente?.oficinaAsesor,
    // ...serviceCredentials,
  };

  return resgisterData;

}

// Set up consult client data

export const setUpConsultClientData = (documentId) => {
  const document = typeof documentId === "string" && documentId !== "";
  let type, cedula, pasaporte, criterio;

  if (document) {
    type = documentId.charAt(0);

    if (type === 'V' || type === 'E') {
      cedula = documentId.replace(/\s/g, '');
      pasaporte = '';
      criterio = 2;
    } else {
      cedula = '';
      pasaporte = documentId.replace(/\s/g, '');
      criterio = 3;
    }
  } else {
    return null;
  }

  const data = {
    cedula: cedula, // <- venenzolano // extranjero: E00188347
    pasaporte: pasaporte, // pasaporte: P1235456 // cedula como string vacio
    criterio: criterio, // criterio 3 para pasaporte
    ...consultClientHiddenFields
  }

  return data;
};

// Set up consult client addresses data

export const setUpConsultClientAddresesData = (documentId) => {
  const document = typeof documentId === "string" && documentId !== "";
  let cedula;

  if (document) {
    cedula = documentId.replace(/\s/g, '');
  } else {
    return null;
  }

  const data = {
    cedulaRif: cedula,
    ...consultClientAddressesFields
  }

  return data;
};

// Format consult client address Info

export const formatConsultClientAddressInfo = (data, type, id) => {
  const addressData = data ? data?.split(",") : null;
  let addressDataFormated;

  if (addressData?.length > 0) {
    const tel = addressData.find(x => x.includes("TEL"))?.split(" ")[1];
    const cel = addressData.find(x => x.includes("CEL"))?.split(" ")[1];

    addressDataFormated = {
      pais: addressData.find(x => x.includes("PAÍS"))?.split(" ")[1],
      estado: addressData.find(x => x.includes("ESTADO"))?.split(" ")[1],
      ciudad: addressData.find(x => x.includes("CIUDAD"))?.split(" ")[1],
      municipio: addressData.find(x => x.includes("MUNICIPIO"))?.split(" ")[1],
      parroquia: addressData.find(x => x.includes("PARROQUIA"))?.split(" ")[1],
      sector: addressData.find(x => x.includes("SECT"))?.split(" ")[1],
      calle: addressData.find(x => x.includes("CALLE"))?.split(" ")[1],
      condicionVivienda: addressData.find(x => x.includes("VIV"))?.split(" ")[1],
      tiempoEnVivienda: addressData.find(x => x.includes("TIEM VIV"))?.split(" ")[2],
      tipoInmueble: addressData.find(x => x.includes("TP INM"))?.split(" ")[2],
      nombreInmueble: addressData.find(x => x.includes("NOM INM"))?.split(" ")[2],
      nivel: addressData.find(x => x.includes("NIV"))?.split(" ")[1],
      piso: addressData.find(x => x.includes("PISO"))?.split(" ")[1],
      torre: addressData.find(x => x.includes("TORRE"))?.split(" ")[1],
      apartamento: addressData.find(x => x.includes("APTO"))?.split(" ")[1],
      codDireccion: id,
      tipo: type,
      tipoDireccion: type,
      descripcionDireccion: data,
      telefono1: {
        codigoArea: tel ? tel.split("-")[0] : "",
        descripcionTipoDireccion: 0,
        identificador: 1,
        numero: tel ? tel.split("-")[1] : "",
        tipo: "T",
        tipoDireccion: type
      },
      telefono2: {
        codigoArea: cel ? cel.split("-")[0] : "",
        descripcionTipoDireccion: 0,
        identificador: 2,
        numero: cel ? cel.split("-")[1] : "",
        tipo: "C",
        tipoDireccion: type
      }
    };
  }

  return addressDataFormated;
};

// Set up client update data

export const setUpClientUpdateData = (data) => {
  let cliente = { ...data.cliente };

  cliente.catEspec = cliente.categoriaEspecial;
  delete cliente.categoriaEspecial;

  cliente.cedula = cliente.tipoDocumento !== 'P' ? cliente.tipoDocumento + cliente.cedulaRif : "";
  cliente.venezolano = cliente.tipoDocumento === 'V' ? "true" : "false";
  delete cliente.cedulaRif;

  cliente.codigoMis = cliente.codCliente;
  delete cliente.codCliente;

  cliente.edoCivil = cliente.estadoCivil;
  delete cliente.estadoCivil;

  cliente.ocupacion = cliente.actividadEspecifica;

  cliente.otraNacionalidad = cliente.codigoOtraNacionalidad ? Number(cliente.codigoOtraNacionalidad) : '99';
  delete cliente.codigoOtraNacionalidad;

  cliente.provincia = Number(cliente.estadoNacimiento);
  delete cliente.estadoNacimiento;

  cliente.codiOf = cliente.oficina;
  cliente.codOficina = cliente.oficina;
  delete cliente.officina;

  cliente.pais = Number(cliente.lugarNacimiento);
  cliente.provincia = Number(cliente.provincia);
  cliente.nacionalidad = Number(cliente.nacionalidad);

  delete cliente.ciudadNacimiento;

  cliente.rif = cliente.tipoRif + cliente.rif;
  delete cliente.tipoRif;

  cliente.pasaporte = cliente.tipoDocumento !== 'P' ? "" : cliente.tipoDocumento + cliente.pasaporte;

  cliente.ciiu = "";
  cliente.riskCodPais = 0;
  cliente.sectorEconomico = 0;

  cliente.nombreCompleto = cliente.nombre + ' ' + cliente.primerApellido + ' ' + cliente.segundoApellido;

  let resgisterData = {
    cliente: {
      ...cliente,
      ...updateClientHiddenFields,
    },
    ...serviceCredentials,
  };

  return resgisterData;
};

// Set up update address data

export const setUpdateAddressData = (data, userId, addressId) => {
  let direccion = { ...insertAddressHiddenFields, ...data };

  direccion.codigoMIS = userId;
  direccion.codDireccion = addressId;

  // Setup Address Values

  direccion.inmueble = direccion.tipoInmueble;

  if (direccion.tipoInmueble === '1') {
    direccion.casa = direccion.nombreInmueble;
  } else if (direccion.tipoInmueble === '5') {
    direccion.edificio = direccion.nombreInmueble;
  } else if (direccion.tipoInmueble === '2') {
    direccion.quinta = direccion.nombreInmueble;
  } else if (direccion.tipoInmueble === '3') {
    direccion.residencia = direccion.nombreInmueble;
  }

  direccion.nivel = direccion.nivel ? direccion.nivel : '';

  direccion.telefono1 = {
    ...direccion.telefono1,
    tipoDireccion: 'T',
  };
  direccion.telefono2 = direccion.telefono2?.numero ? {
    ...direccion.telefono2,
    tipoDireccion: 'T'
  } : {
    codigoArea: "000",
    descripcionTipoDireccion: 0,
    identificador: 2,
    numero: 0,
    tipo: "T",
    tipoDireccion: 0
  };
  direccion.telefono3 = {
    codigoArea: "000",
    descripcionTipoDireccion: 0,
    identificador: 3,
    numero: 0,
    tipo: "T",
    tipoDireccion: 0
  };

  direccion.descDireccion = `PAÍS ${direccion.pais},ESTADO ${direccion.entidad},CIUDAD ${direccion.ciudad},MUNICIPIO ${direccion.municipio},PARROQUIA ${direccion.parroquia},SECT ${direccion.urbanizacion},${direccion.avenida},TP INM ${direccion.tipoInmueble},NOM INM ${direccion.nombreInmueble},NIV ${direccion.piso},TEL ${direccion.telefono1.codigoArea + direccion.telefono1.numero},CEL ${direccion.telefono2.codigoArea + direccion.telefono2.numero}`;

  delete direccion.nombreInmueble;

  return { direccion: direccion };
};

// Set Nested Field Name

export const setNestedFieldName = (fieldName, formValues) => {
  return fieldName.split(".").reduce((o, i) => o[i], formValues);
};

// Set Nested Field Error

export const setNestedFieldError = (fieldName, formValues) => {
  return fieldName.split(".").reduce((o, i) => {
    if (o) {
      return o[i];
    }
  }, formValues);
};


// Add Item to Array

export const addItemToArray = (formik, fieldName, item) => {
  const items = fieldName.includes(".")
    ? setNestedFieldName(fieldName, formik.values)
    : formik.values[fieldName];
  const fieldData = [...items];

  fieldData.push(item ? item : {});

  formik.setFieldValue(fieldName, fieldData);
};

// Remove Item from Array

export const removeItemFromArray = (formik, fieldName) => {
  const items = fieldName.includes(".")
    ? setNestedFieldName(fieldName, formik.values)
    : formik.values[fieldName];
  const fieldData = [...items];

  fieldData.pop();

  formik.setFieldValue(fieldName, fieldData);
};

// Format dropdown options

export const formatDropDownOptions = (options) => {
  const items = options
    ? options?.map((option) => ({
      value: option.value,
      label: option.name
    }))
    : [];

  return items;
};

export const formatDropDownOptionsNationality = (options) => {
  const items = options
    ? options?.map((option) => ({
      value: option.value,
      label: option.nationality
    }))
    : [];

  return items;
};

export const formatDropDownOptionsAlt = (options) => {
  const items = options
    ? options?.map((option) => ({
      value: option.name,
      label: option.name
    }))
    : [];

  return items;
};

export const formatDropDownOptionsWithValueAsName = (options) => {
  const items = options
    ? options?.map((option) => ({
      value: option.value,
      label: option.value
    }))
    : [];

  return items;
};


// Format account product options

export const formatAccountProductOptions = (options, categoryId) => {
  const items = options
    ? options?.map((option) => ({
      categoryId: categoryId,
      moneda: option.moneda,
      value: option.value,
      label: option.name
        ?.toLowerCase()
        .replace(/\w/, (firstLetter) => firstLetter.toUpperCase()),
    }))
    : [];

  return items;
};


// Get DocumentType Value from Document Number

export const getDocumentTypeValueFromDocumentNumber = (data) => {
  const cedula = typeof data?.cedulaRif === "string" && data?.cedulaRif !== "";
  const pasaporte =
    typeof data?.pasaporte === "string" && data?.pasaporte !== "";
  let value;

  if (cedula) {
    value = data?.cedulaRif?.charAt(0);
  } else if (pasaporte) {
    value = data?.pasaporte?.charAt(0);
  } else {
    value = "";
  }

  return value;
};


// Get RifType Value from Rif Number

export const getRifTypeValueFromRifNumber = (data) => {
  const rif = typeof data?.rif === "string" && data?.rif !== "";
  let value;

  if (rif) {
    value = data?.rif?.charAt(0)?.toUpperCase();
  } else {
    value = "";
  }

  return value;
};


// Format consult personal references Info

export const formatPersonalReferences = (data) => {
  const personalReferenceData = data;

  return {
    cedulaReferencia: personalReferenceData.cedulaReferencia,
    codigoParentesco: personalReferenceData.codigoParentesco,
    direccion: personalReferenceData.direccion,
    fechaRegistro: personalReferenceData.fechaRegistro,
    fechaUltModif: personalReferenceData.fechaUltModif,
    nombre: personalReferenceData.nombre,
    numero: personalReferenceData.numero,
    parentesco: personalReferenceData.parentesco,
    primerApellido: personalReferenceData.primerApellido,
    segundoApellido: personalReferenceData.segundoApellido,
    telefonoDomicilio: personalReferenceData.telefonoDomicilio,
    telefonoEmpresa: personalReferenceData.telefonoEmpresa,
    telefonoOtro: personalReferenceData.telefonoOtro,
    verificado: personalReferenceData.verificado,
    vigente: personalReferenceData.vigente,
    descripcionpersonalReference: data,
  };
};

// Format consult economic references Info

export const formatReferenciasEconomicas = (data) => {
  const personalReferenceData = data;

  return {
    banco: personalReferenceData.banco,
    calificacion: personalReferenceData.calificacion,
    clase: personalReferenceData.clase,
    codNotificacion: personalReferenceData.codNotificacion,
    descripcion: personalReferenceData.descripcion,
    estatus: personalReferenceData.estatus,
    fechaCompra: personalReferenceData.fechaCompra,
    fechaConstancia: personalReferenceData.fechaConstancia,
    institucion: personalReferenceData.institucion,
    institucionFinanciera: personalReferenceData.institucionFinanciera,
    moneda: personalReferenceData.moneda,
    nombreTarjeta: personalReferenceData.nombreTarjeta,
    nombreTdc: personalReferenceData.nombreTdc,
    numero: personalReferenceData.numero,
    numeroCifras: personalReferenceData.numeroCifras,
    numeroCuenta: personalReferenceData.numeroCuenta,
    descripcionpersonalReference: data,
    numeroLista: personalReferenceData.numeroLista,
    numeroTarjeta: personalReferenceData.numeroTarjeta,
    numeroTdc: personalReferenceData.numeroTdc,
    observacion: personalReferenceData.observacion,
    operacion: personalReferenceData.operacion,
    secuencial: personalReferenceData.secuencial,
    tarjeta: personalReferenceData.tarjeta,
    tipo: personalReferenceData.tipo,
    tipoCifras: personalReferenceData.tipoCifras,
    tipoCuenta: personalReferenceData.tipoCuenta,
  };
};

// Set up insert personal reference data

export const setInsertPersonalReferenceData = (data, userId) => {
  let referencia = { ...data };

  referencia.mis = userId;

  return { referencia: referencia };
};

// Set up insert economic reference data

export const setInsertEconomicReferenceData = (data, userId) => {
  let referencia = { ...data };

  referencia.canal = 1;
  referencia.oficina = 165;
  referencia.oficinaAsesor = 159;
  referencia.codigoMisCliente = userId;

  return { referencia: referencia };
};

// Set up insert job data

export const setInsertJobData = (data, userId, addressId) => {
  let job = {
    proximoEmpleoIngreso: 0,
    codigoMisCliente: userId,
    empleo: {
      ...data,
      codigoDireccion: addressId,
      rif: data?.rifType + data?.rif,
      fechaCons: data?.fechaConsIng,
      otraMoneda: data?.otraMoneda ? data?.otraMoneda : 0,
      sueldoBonificacion: data?.sueldoBonificacion ? data?.sueldoBonificacion : 0,
      fechaModificacion: "2023-01-04T10:22:53-04:30",
      fuenteIngreso: 0,
      numero: 1,
      tiempoLaborado: 0,
      verif: "S",
      vigencia: "S"
    }
  };

  delete job.empleo.rifType;

  return job;
};

// Set up insert income data

export const setInsertIncomeData = (data, userId, addressId) => {
  let income = {
    oficinaAsesor: 165,
    proximoEmpleoIngreso: 0,
    codigoMisCliente: userId,
    ingreso: {
      ...data,
      concepto: 0,
      codigoDireccion: addressId,
      id: 7,
    }
  };

  return income;
};


// Set up insert income data for Housewife and Student

export const setInsertIncomeDataHousewifeStudent = (data, userId) => {
  let income = {
    oficinaAsesor: 165,
    proximoEmpleoIngreso: 0,
    codigoMisCliente: userId,
    ingreso: {
      fechaConsIng: data.fechaDesdeCuandoRecibeIngreso,
      moneda: data.codigoMonedaIngreso,
      montoEstimado: data.montoEstimadoDeIngreso,
      otrosIngresos: data.actividadGeneradoraIngreso,
      concepto: data.descripcionDeIngreso,
      codigoDireccion: 2,
      id: 2,
    }
  };

  return income;
};

// Set up insert business data

export const setInsertBusinessData = (data, userId) => {
  let business = {
    ...data,
    codigoMis: userId,
    operacion: 1,
    rif: data?.rifType + data?.rif,
  };

  return business;
};

// Set up business provider or client data

export const setInsertBusinessProviderOrClientData = (data, userId, businessId) => {
  let entry = {
    ...data,
    codigoMis: userId,
    idClienteProveedor: businessId,
    operacion: 1,
  };

  return entry;
};

// Set up insert address data

export const setInsertAddressData = (data, userId) => {
  let entry = {
    direccion: {
      ...data,
      codigoMIS: userId,
      codDireccion: 0,
      identificador: 0,
      oficinaBanco: 165,
      principal: 0,
      inmueble: data.tipoInmueble,
      edificio: "",
      local: "",
      facebook: "",
      twitter: "",
      instagram: "",
      email: "",
      descDireccion: `PAIS ${data.nombrePais}, AVENIDA/CALLE ${data.avenida},URB/SECTOR ${data.urbanizacion},CIUDAD ${data.ciudad},ENTIDAD ${data.entidad},TEL ${data.telefono1.codigoArea + '-' + data.telefono1.numero}`,
      telefono1: {
        ...data.telefono1,
        tipoDireccion: 'T',
      },
      telefono2: data.telefono2?.numero ? {
        ...data.telefono2,
        tipoDireccion: 'T'
      } : {
        codigoArea: "000",
        descripcionTipoDireccion: 0,
        identificador: 2,
        numero: 0,
        tipo: "T",
        tipoDireccion: 0
      },
      telefono3: {
        codigoArea: "000",
        descripcionTipoDireccion: 0,
        identificador: 3,
        numero: 0,
        tipo: "T",
        tipoDireccion: 0
      },
      tipo: 'D',
      tipoDireccion: "D",
      verificado: "S",
      vigente: "S"
    }
  };

  return entry;
};


// Set up insert international address data

export const setInsertInternationalAddressData = (data, userId) => {
  let entry = {
    direccion: {
      ciudad: 1,
      pais: data.pais,
      codDireccion: 0,
      codigoMIS: userId,
      descDireccion: `PAIS ${data.nombrePais}, ${data.descDireccion}`,
      identificador: 0,
      oficinaBanco: 165,
      telefono1: {
        ...data.telefono1,
        tipoDireccion: 'T',
      },
      telefono2: data.telefono2?.numero ? {
        ...data.telefono2,
        tipoDireccion: 'T'
      } : {
        codigoArea: "000",
        descripcionTipoDireccion: 0,
        identificador: 2,
        numero: 0,
        tipo: "T",
        tipoDireccion: 0
      },
      telefono3: {
        codigoArea: "000",
        descripcionTipoDireccion: 0,
        identificador: 3,
        numero: 0,
        tipo: "T",
        tipoDireccion: 0
      },
      tipo: 'I',
      tipoDireccion: "I",
      verificado: "S",
      vigente: "S"
    }
  };

  return entry;
};

// Set up update international address data

export const setUpdateInternationalAddressData = (data, userId, codDireccion) => {
  let entry = {
    direccion: {
      ciudad: 1,
      pais: data.pais,
      codDireccion: codDireccion,
      codigoMIS: userId,
      descDireccion: `PAIS ${data.nombrePais}, ${data.descDireccion}`,
      identificador: 0,
      oficinaBanco: 165,
      telefono1: {
        ...data.telefono1,
        tipoDireccion: 'T',
      },
      telefono2: data.telefono2?.numero ? {
        ...data.telefono2,
        tipoDireccion: 'T'
      } : {
        codigoArea: "000",
        descripcionTipoDireccion: 0,
        identificador: 2,
        numero: 0,
        tipo: "T",
        tipoDireccion: 0
      },
      telefono3: {
        codigoArea: "000",
        descripcionTipoDireccion: 0,
        identificador: 3,
        numero: 0,
        tipo: "T",
        tipoDireccion: 0
      },
      tipo: data?.tipoDireccion,
      tipoDireccion: data?.tipoDireccion,
      verificado: "S",
      vigente: "S"
    }
  };

  return entry;
};

// Set up insert job address data

export const setInsertJobAddressData = (data, userId, jobType) => {
  let entry = {
    direccion: {
      ...data,
      codigoMIS: userId,
      codDireccion: 0,
      identificador: 0,
      oficinaBanco: 165,
      principal: 0,
      inmueble: data.tipoInmueble,
      facebook: "",
      twitter: "",
      instagram: "",
      email: "",
      casa: data.tipoInmueble === '1' ? data.nombreInmueble : '',
      edificio: data.tipoInmueble === '5' ? data.nombreInmueble : '',
      quinta: data.tipoInmueble === '2' ? data.nombreInmueble : '',
      residencia: data.tipoInmueble === '3' ? data.nombreInmueble : '',
      centroComercial: data.tipoInmueble === '4' || data.tipoInmueble === '6' ? data.nombreInmueble : '',
      descDireccion: `${data.nombrePais}, ${data.entidad}, ${data.ciudad}, ${data.municipio}, ${data.parroquia}, ${data.urbanizacion},${data.callecarretera},${data.calle},${data.avenida},${data.esquina},OBSERVACIONES ${data.observaciones},TP INM ${data.tipoInmueble},NOM INM ${data.nombreInmueble},NIV ${data.piso},TEL ${data.telefono1.codigoArea + ' ' + data.telefono1.numero}`,
      telefono1: {
        ...data.telefono1,
        tipoDireccion: jobType,
      },
      telefono2: {
        codigoArea: "000",
        descripcionTipoDireccion: 0,
        identificador: 2,
        numero: 0,
        tipo: "T",
        tipoDireccion: 0
      },
      telefono3: {
        codigoArea: "000",
        descripcionTipoDireccion: 0,
        identificador: 3,
        numero: 0,
        tipo: "T",
        tipoDireccion: 0
      },
      tipo: jobType,
      tipoDireccion: jobType,
      verificado: "S",
      vigente: "S"
    }
  };

  return entry;
};

// Set up insert international job address data

export const setInsertInternationalJobAddressData = (data, userId, jobType) => {
  let entry = {
    direccion: {
      ciudad: 1,
      pais: data.pais,
      codDireccion: 0,
      codigoMIS: userId,
      descDireccion: `PAIS ${data.nombrePais}, ${data.descDireccion},TEL ${data.telefono1.codigoArea + '-' + data.telefono1.numero}`,
      identificador: 0,
      oficinaBanco: 165,
      telefono1: {
        ...data.telefono1,
        tipoDireccion: 'T',
      },
      telefono2: {
        codigoArea: "000",
        descripcionTipoDireccion: 0,
        identificador: 2,
        numero: 0,
        tipo: "T",
        tipoDireccion: 0
      },
      telefono3: {
        codigoArea: "000",
        descripcionTipoDireccion: 0,
        identificador: 3,
        numero: 0,
        tipo: "T",
        tipoDireccion: 0
      },
      tipo: jobType,
      tipoDireccion: jobType,
      verificado: "S",
      vigente: "S"
    }
  };

  return entry;
};

// Set update facta data

export const setUpdateFatcaData = (data, userId, office) => {
  const response = data?.tieneRelacion === 'si' ? 1 : 0;

  let entry = {
    codigoMis: userId,
    itin: response,
    ciudadano: response,
    residente: response,
    codigoPostal: response,
    greenCard: response,
    numitin: data?.numitin,
    canal: 1,
    telefono: 0,
    correo: 0,
    direccion: 0,
    numgiin: 1,
    oficinaAsesor: office
  };

  return entry;
};


// Set up insert customer pep question 1 data

export const setInsertCustomerPepQuestion1Data = (data, userId) => {
  if (data.nombreCargo !== '0') {

    // Respuestas Positiva Pregunta # 1

    return {
      actividad: data.nombreCargo,
      mis: userId,
      modo: 9,
      nombreCargo: data.nombreCargo,
      pais: data.pais,
      nombreEnteAdscrito: data.nombreEnteAdscrito,
      pregunta: 1,
      respuesta: 1
    };
  } else {

    // Respuestas Negativa Pregunta # 1

    return {
      mis: userId,
      modo: 5,
      pregunta: 1,
      respuesta: 0,
      asociadoId: 1,
      cantidad: 1
    };
  }
};

// Set up insert customer pep question 2 data

export const setInsertCustomerPepQuestion2Data = (data, userId, hasAssociate, asociadoId, cantidad) => {
  if (hasAssociate !== 'no') {

    // Respuestas Positiva Pregunta # 2

    return {
      ...data,
      documentoIdentidad: data?.lugarNacimiento === '0' ? 'V' + data?.documentoIdentidad : 'E' + data?.documentoIdentidad,
      otraNacionalidad: data.otraNacionalidad ? Number(data.otraNacionalidad) : '99',
      mis: userId,
      modo: 9,
      pregunta: 2,
      respuesta: 1,
      tipoLugarNacimiento: data?.lugarNacimiento === '0' ? 'V' : 'E',
      asociadoId: asociadoId,
      cantidad: cantidad
    };
  } else {

    // Respuestas Negativa Pregunta # 2

    return {
      mis: userId,
      modo: 5,
      pregunta: 2,
      respuesta: 0,
      asociadoId: 1,
      cantidad: 1
    };
  }
};


// function setFormatDate(fechaNacimiento){

//   const [year, month, day] = fechaNacimiento.split("-");

//   const date = new Date(`${year}`, month - 1, day);

//   const formattedYear = date.getUTCFullYear();
//   const formattedMonth = (`${date.getUTCMonth() + 1}`.slice(-2).length == 1)? `0${date.getUTCMonth() + 1}`.slice(-2) : `${date.getUTCMonth() + 1}`.slice(-2);
//   const formattedDay = `${date.getUTCDate()}`.slice(-2);

//   return `${formattedYear}-${formattedMonth}-${formattedDay}T00:00:00-04:30`;
// }


// Set insert spouse relaiton data

export const setInsertSpouseRelationData = (data, userId, spouseId, office) => {
  let entry = {
    codigoMis: userId,
    operacion: "I",
    oficinaAsesor: office,
    relacion: {
      codigoMis: spouseId,
      codigoRelacion: 8,
      nombreCompleto: data?.nombre + ' ' + data?.primerApellido + ' ' + data?.segundoApellido,
      nombreRelacion: data?.nombreRelacion
    }
  };

  return entry;
};


// Set insert representative relaiton

export const setInsertRepresentativeRelation = (data, userId, representativeId, office) => {
  let entry = {
    codigoMis: userId,
    operacion: "I",
    oficinaAsesor: office,
    relacion: {
      codigoMis: representativeId,
      codigoRelacion: 14,
      nombreCompleto: data?.nombre + ' ' + data?.primerApellido + ' ' + data?.segundoApellido,
      nombreRelacion: "APODERADO"
    }
  };

  return entry;
};


// Set insert representative relation data

export const setInsertRepresentativeRelationData = (data, userId, representativeId, office) => {
  let entry = {
    codigoMis: userId,
    operacion: "I",
    oficinaAsesor: office,
    apoderado: {
      fechaRegistro: data?.fechaRegistro,
      identificacionRegistro: data?.identificacionRegistro,
      numeroRegistro: data?.numeroRegistro,
      protocolo: data?.protocolo,
      tomoRegistro: data?.tomoRegistro,
      identificacion: {
        codigoMis: representativeId,
        nombreCompleto: data?.nombre + ' ' + data?.primerApellido + ' ' + data?.segundoApellido,
      }
    }
  };

  return entry;
};


// Set open account and product data

export const setOpenAccountAndProductData = (data, userId, addressId, product) => {
  let entry = {
    chequerasprevias: "false",
    envio: "D",
    usaLibreta: 0,
    email: data?.cliente?.mail,
    origenFondos: product?.origenFondos,

    apartado: {
      id: 0,
      numero: 1,
      tipo: 0,
      ciudad: data?.movilizacionProductos?.ciudad,
      codigoSucursal: data?.cliente?.oficinaAsesor,
      entidad: data?.movilizacionProductos?.entidad,
      sucursal: data?.cliente?.oficinaAsesor,
    },
    aperturaCuentaBean: {
      cantDepositos: product?.cantDepositos,
      cantRetiros: product?.cantRetiros,
      montoPromedio: product?.montoPromedio,

      categoriaCuenta: (product?.categoriaProducto === "3" || product?.categoriaProducto === "4") ? "N" : "U",
      condicionFirma: "FIRMA ÚNICA",
      detalle: 10586851,
      firmas: 4,
      montoDeposito: 1,
      montoRetiro: 1,
      monedaVirtual: product?.usaMonedaVirtual === 'si' ? product?.monedaVirtual : 0,
      numeroAutorizados: 0,
      oficial: "bc22334",
      totalApertura: 0,
      descripcionMontDep: data?.movilizacionProductos?.totalIngresos === 0 ? "0 - 0" : product?.descripcionMontDep,
      descripcionMontRet: data?.movilizacionProductos?.totalIngresos === 0 ? "0 - 0" : product?.descripcionMontRet,
      motivoApertura: product?.motivoApertura,
      nombreTitular: data?.cliente?.nombre + ' ' + data?.cliente?.primerApellido + ' ' + data?.cliente?.segundoApellido,

      // transferencia: product?.recibeDelExterior === 'si' ? 1 : 0,
      // paisOrigen: product?.recibeDelExterior === 'si' ? product?.paisOrigen : 0,

      // transferenciaEnvia: product?.enviaAlExterior === 'si' ? 1 : 0,
      // paisDestino: product?.enviaAlExterior === 'si' ? product?.paisDestino : 0,

      transferencia: 0,
      paisOrigen: 0,

      transferenciaEnvia: 0,
      paisDestino: 0,

      uso: product?.destinoFondos,
    },
    direccion: {
      codigoDireccion: addressId,
      descripcionDireccion: `PAÍS ${data?.direccion?.pais},ESTADO ${data?.direccion?.entidad},CIUDAD ${data?.direccion?.ciudad},MUNICIPIO ${data?.direccion?.municipio},PARROQUIA ${data?.direccion?.parroquia},SECT ${data?.direccion?.urbanizacion},${data?.direccion?.calle},TP INM ${data?.direccion?.tipoInmueble},NOM INM ${data?.direccion?.nombreInmueble},NIV ${data?.direccion?.piso},TEL ${data?.direccion?.telefono1.codigoArea + data?.direccion?.telefono1.numero}`,
      tipoDireccion: "D"
    },
    participantes: {
      ParticipanteBean: {
        BDSeguridad: "true",
        actividadEconomica: data?.cliente?.actividadEconomica,
        cedula: data?.cliente.tipoDocumento !== 'P' ? data?.cliente.tipoDocumento + data?.cliente?.cedulaRif : data?.cliente.tipoDocumento + data?.cliente?.pasaporte,
        ciiu: data?.cliente?.actividadEconomica,
        codOficina: data?.cliente?.oficinaAsesor,
        codigoMis: userId,
        codigoMisRepresentante: 0,
        comentarios: "Apartura Cuenta Onboarding",
        direcciones: {
          Direcciones: {
            codigoDireccion: addressId,
            descripcionDireccion: `PAÍS ${data?.direccion?.pais},ESTADO ${data?.direccion?.entidad},CIUDAD ${data?.direccion?.ciudad},MUNICIPIO ${data?.direccion?.municipio},PARROQUIA ${data?.direccion?.parroquia},SECT ${data?.direccion?.urbanizacion},${data?.direccion?.calle},TP INM ${data?.direccion?.tipoInmueble},NOM INM ${data?.direccion?.nombreInmueble},NIV ${data?.direccion?.piso},TEL ${data?.direccion?.telefono1.codigoArea + data?.direccion?.telefono1.numero}`,
            tipoDireccion: "D"
          }
        },
        esOficinaBangente: 0,
        grupoEconomico: 0,
        identificacion: 0,
        lenguaje: 0,
        firmar: "true",
        patrimonioTecnico: 0,
        referencia: 0,
        riskCodPais: 0,
        rol: "T",
        segmento: 0,
        subSegmento: 0,
        tipoCliente: 1,
        tipoFirma: "X",
        tipoIdentificacion: 1,
        tipoPersona: "N",
        vinculacion: 0,
        referenciasBancarias: "false",
        edoCivil: data?.cliente.estadoCivil,
        fechaUltimaModificacion: "2022-06-27T15:15:22-04:30",
        fechaNacimiento: data?.cliente?.fechaNacimiento,
        fechaVenceIdentificacion: data?.cliente?.fechaVenceIdentificacion,
        fuenteOrigen: product?.origenFondos,
        lugarNacimiento: data?.cliente?.lugarNacimiento,
        nacionalidad: data?.cliente?.nacionalidad,
        nombre: data?.cliente?.nombre + ' ' + data?.cliente?.primerApellido + ' ' + data?.cliente?.segundoApellido,
        oficina: data?.cliente?.oficinaAsesor,
        pais: data?.cliente?.nacionalidad,
        profesion: data?.cliente?.profesion,
        provincia: data?.cliente?.estadoNacimiento,
        sexo: data?.cliente?.sexo,
        venezolano: data?.cliente?.tipoDocumento === 'V' ? "true" : "false",
      }
    },
    producto: {
      categoria: product?.monedaProducto === "VES" ? "N" : "U",
      codigo: product?.idDelProducto,
      codigoCuenta: product?.categoriaProducto !== "4" ? "CTE" : "AHO",
      moneda: {
        codigoBanco: "-1",
        codigoISO: product?.monedaProducto,
        extranjera: product?.monedaProducto === "VES" ? "false" : "true"
      },
      tipoCuenta: product?.categoriaProducto !== "4" ? "3" : "4",
    },
    oficinaAsesor: data?.cliente?.oficinaAsesor,
  };

  return entry;
};


// Set open account and product data for existing client

export const setOpenAccountAndProductDataExistingClient = (data, userId, address, product) => {
  let entry = {
    chequerasprevias: "false",
    envio: "D",
    usaLibreta: 0,
    email: data?.cliente?.email,
    origenFondos: product?.origenFondos,

    apartado: {
      id: 0,
      numero: 1,
      tipo: 0,
      ciudad: data?.movilizacionProductos?.ciudad,
      codigoSucursal: data?.cliente?.oficinaAsesor,
      entidad: data?.movilizacionProductos?.entidad,
      sucursal: data?.cliente?.oficinaAsesor,
    },
    aperturaCuentaBean: {
      cantDepositos: product?.cantDepositos,
      cantRetiros: product?.cantRetiros,
      montoPromedio: product?.montoPromedio,

      categoriaCuenta: (product?.categoriaProducto === "3" || product?.categoriaProducto === "4") ? "N" : "U",
      condicionFirma: "FIRMA ÚNICA",
      detalle: 10586851,
      firmas: 4,
      montoDeposito: 1,
      montoRetiro: 1,
      monedaVirtual: product?.usaMonedaVirtual === 'si' ? product?.monedaVirtual : 0,
      numeroAutorizados: 0,
      oficial: "bc22334",
      totalApertura: 0,
      descripcionMontDep: data?.movilizacionProductos?.totalIngresos === 0 ? "0 - 0" : product?.descripcionMontDep,
      descripcionMontRet: data?.movilizacionProductos?.totalIngresos === 0 ? "0 - 0" : product?.descripcionMontRet,
      motivoApertura: product?.motivoApertura,
      nombreTitular: data?.cliente?.nombre + ' ' + data?.cliente?.primerApellido + ' ' + data?.cliente?.segundoApellido,

      // transferencia: product?.recibeDelExterior === 'si' ? 1 : 0,
      // paisOrigen: product?.recibeDelExterior === 'si' ? product?.paisOrigen : 0,

      // transferenciaEnvia: product?.enviaAlExterior === 'si' ? 1 : 0,
      // paisDestino: product?.enviaAlExterior === 'si' ? product?.paisDestino : 0,

      transferencia: 0,
      paisOrigen: 0,

      transferenciaEnvia: 0,
      paisDestino: 0,

      uso: product?.destinoFondos,
    },
    direccion: address,
    participantes: {
      ParticipanteBean: {
        BDSeguridad: "true",
        actividadEconomica: data?.cliente?.actividadEconomica,
        cedula: data?.cliente.cedulaRif,
        ciiu: data?.cliente?.actividadEconomica,
        codOficina: data?.cliente?.oficinaAsesor,
        codigoMis: userId,
        codigoMisRepresentante: 0,
        comentarios: "Apartura Cuenta Onboarding",
        direcciones: {
          Direcciones: address
        },
        esOficinaBangente: 0,
        grupoEconomico: 0,
        identificacion: 0,
        lenguaje: 0,
        firmar: "true",
        patrimonioTecnico: 0,
        referencia: 0,
        riskCodPais: 0,
        rol: "T",
        segmento: 0,
        subSegmento: 0,
        tipoCliente: 1,
        tipoFirma: "X",
        tipoIdentificacion: 1,
        tipoPersona: "N",
        vinculacion: 0,
        referenciasBancarias: "false",
        edoCivil: data?.cliente.estadoCivil,
        fechaUltimaModificacion: "2022-06-27T15:15:22-04:30",
        fechaNacimiento: data?.cliente?.fechaNacimiento,
        fechaVenceIdentificacion: data?.cliente?.fechaVenceIdentificacion,
        fuenteOrigen: product?.origenFondos,
        lugarNacimiento: data?.cliente?.lugarNacimiento,
        nacionalidad: data?.cliente?.nacionalidad,
        nombre: data?.cliente?.nombre + ' ' + data?.cliente?.primerApellido + ' ' + data?.cliente?.segundoApellido,
        oficina: data?.cliente?.oficinaAsesor,
        pais: data?.cliente?.nacionalidad,
        profesion: data?.cliente?.profesion,
        provincia: data?.cliente?.estadoNacimiento,
        sexo: data?.cliente?.sexo,
        venezolano: data?.cliente?.tipoDocumento === 'V' ? "true" : "false",
      }
    },
    producto: {
      categoria: product?.monedaProducto === "VES" ? "N" : "U",
      codigo: product?.idDelProducto,
      codigoCuenta: product?.categoriaProducto !== "4" ? "CTE" : "AHO",
      moneda: {
        codigoBanco: "-1",
        codigoISO: product?.monedaProducto,
        extranjera: product?.monedaProducto === "VES" ? "false" : "true"
      },
      tipoCuenta: product?.categoriaProducto !== "4" ? "3" : "4",
    },
    oficinaAsesor: data?.cliente?.oficinaAsesor,
  };

  return entry;
};


// Handle Client Partial Data Redirect

export const handleClientPartialDataRedirect = (data, navigate) => {
  const clientEmail = localStorage.getItem("clientEmail");

  if (data?.email) {

    if (data?.is_completed) {

      navigate('/usuarioregistrado', { state: { userPartialData: data } });

    } else if (data?.is_blocked) {

      navigate('/solicitud', { state: { userPartialData: data } });

    } else if (data?.selected_product) {

      navigate('/registro', { state: { userPartialData: data } });

    } else if (data?.checked_list) {

      navigate('/tipocuenta', { state: { userPartialData: data } });

    } else {

      if (clientEmail) {
        navigate('/infodedocumento', { state: { userPartialData: data } });
      } else {
        navigate('/');
      }

    }

  } else {

    if (clientEmail) {
      navigate('/infodedocumento', { state: { userPartialData: data } });
    } else {
      navigate('/');
    }

  }

};


// Validate upload file extension

const validFileExtensions = { extensions: ['jpeg', 'jpg', 'png', 'pdf'] };

export const isValidFileType = (fileName, fileType) => {
  return fileName && validFileExtensions[fileType].indexOf(fileName.split('.').pop()) > -1;
}